import { TOI_LIVE_DOMAIN } from '../../../../../constants';

export const getPlayerKey = playerkey =>
  playerkey && typeof playerkey === 'string'
    ? playerkey
        .split(' ')
        .join('-')
        .toUpperCase()
    : playerkey;

export const getPlayerLink = (isIpl, playerkey, id, tournamentName) => {
  playerkey = getPlayerKey(playerkey);
  const playerLink =
    isIpl || (tournamentName === 'ipl' || tournamentName === 'wpl')
      ? `${TOI_LIVE_DOMAIN}/sports/cricket/${tournamentName ||
          'ipl'}/player-stats/${playerkey?.toLowerCase()}/${id}`
      : `${TOI_LIVE_DOMAIN}/sports/cricket/player-profile/${playerkey?.toLowerCase()}/${id}`;
  // `${TOI_LIVE_DOMAIN}/topic/${playerkey}`;
  return playerLink;
};
